import * as z from "zod/v4";

export const triggerLifecycleRecomputeInputSchema = z.object({});
export type TriggerLifecycleRecomputeInput = z.infer<
  typeof triggerLifecycleRecomputeInputSchema
>;

export const triggerLifecycleRecomputeOutputSchema = z.object({
  success: z.boolean(),
  workflowId: z.string().nullable(),
  error: z.string().nullable(),
});
export type TriggerLifecycleRecomputeOutput = z.infer<
  typeof triggerLifecycleRecomputeOutputSchema
>;

export const triggerLifecycleRecompute = {
  name: "triggerLifecycleRecompute" as const,
  input: triggerLifecycleRecomputeInputSchema,
  output: triggerLifecycleRecomputeOutputSchema,
};
